export default __webpack_public_path__ + "static/media/6.8f483b83.png";